"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionWidget = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Declarative_1 = require("../../utils/Declarative");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var AccordionStyleName = TypeStyle.style({
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    $nest: {
        '&.showDividers > * + *::before': {
            backgroundColor: '#E6E6E6',
            content: "\"\"",
            height: 1,
            marginBottom: 8,
            width: '100%', // ensures the divider can still extend the full width when the expando root element doesn't have `align-items: stretch`
        },
    }
});
/**
 * Accordion is a vertically stacked list of two or more `ExpandoWidget` which reveal or hide additional sections of content.
 */
exports.AccordionWidget = React.forwardRef(function (props, accordionRef) {
    var autoCollapse = props.autoCollapse, children = props.children, showDividers = props.showDividers, testId = props.testId, htmlAttrs = tslib_1.__rest(props, ["autoCollapse", "children", "showDividers", "testId"]);
    var expandoRefs = React.useRef([]);
    React.useEffect(function () {
        expandoRefs.current = expandoRefs.current.slice(0, children.length);
    }, [children]);
    React.useImperativeHandle(accordionRef, function () { return ({
        toggleAt: function (expandoIndex, expanded) { var _a; return (_a = expandoRefs.current[expandoIndex]) === null || _a === void 0 ? void 0 : _a.toggle(expanded); },
        toggleAll: function (expanded) { return expandoRefs.current.forEach(function (expando) { return expando === null || expando === void 0 ? void 0 : expando.toggle(expanded); }); },
    }); });
    return React.createElement("div", tslib_1.__assign({ "data-tb-test-id": Declarative_1.makeTestId(testId, 'AccordionWidget') }, htmlAttrs, { className: TypeStyle.classes(AccordionStyleName, { showDividers: showDividers }, htmlAttrs.className) }), children.map(function (expandoEl, index) { return React.cloneElement(expandoEl, tslib_1.__assign(tslib_1.__assign({}, (autoCollapse && {
        onExpand: function () {
            var _a, _b;
            expandoRefs.current.forEach(function (expando, expandoIndex) {
                if (expandoIndex !== index) {
                    expando === null || expando === void 0 ? void 0 : expando.toggle(false);
                }
            });
            (_b = (_a = expandoEl.props).onExpand) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    })), { ref: function (expandoRef) {
            expandoRefs.current[index] = expandoRef;
            ReactHelpers_1.assignRef(expandoEl.ref, expandoRef);
        } })); }));
});
exports.AccordionWidget.displayName = 'AccordionWidget';
//# sourceMappingURL=AccordionWidget.js.map